/**
 * @generated SignedSource<<dc6869ba368c35419c0c486be19bdc0f>>
 * @relayHash 56e42d5e2c1d8f0edfe99c508579f470
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f3677a4399037c11ec7caf2f751c3658bacaded633e1f205ce79bf2748029b9

import type { ConcreteRequest } from 'relay-runtime';
export type useDataMacroBodyContentConverterQuery$variables = {
  content: string;
  contentId: string;
  from: string;
  spaceKeyContext?: string | null | undefined;
  to: string;
};
export type useDataMacroBodyContentConverterQuery$data = {
  readonly contentConverter: {
    readonly value: string | null | undefined;
  } | null | undefined;
};
export type useDataMacroBodyContentConverterQuery = {
  response: useDataMacroBodyContentConverterQuery$data;
  variables: useDataMacroBodyContentConverterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v3 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "spaceKeyContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "content",
        "variableName": "content"
      },
      {
        "kind": "Variable",
        "name": "contentIdContext",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "spaceKeyContext",
        "variableName": "spaceKeyContext"
      },
      {
        "kind": "Variable",
        "name": "to",
        "variableName": "to"
      }
    ],
    "concreteType": "ConfluenceBody",
    "kind": "LinkedField",
    "name": "contentConverter",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useDataMacroBodyContentConverterQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useDataMacroBodyContentConverterQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "56e42d5e2c1d8f0edfe99c508579f470",
    "id": "2f3677a4399037c11ec7caf2f751c3658bacaded633e1f205ce79bf2748029b9",
    "metadata": {},
    "name": "useDataMacroBodyContentConverterQuery",
    "operationKind": "query",
    "text": "query useDataMacroBodyContentConverterQuery($content:String!,$contentId:ID!,$from:String!,$to:String!,$spaceKeyContext:String=\"\"){contentConverter(from:$from,to:$to,content:$content,contentIdContext:$contentId,spaceKeyContext:$spaceKeyContext){value}}"
  }
};
})();

(node as any).hash = "d7a05ea0544a617dbda390e788d71eb7";

export default node;
